import { ContactQuestion } from "./contact-question";
import type { QuestionTypeRendererProps } from "./shared";

type YesNoQuestionProps = QuestionTypeRendererProps<"yes_no">;

export default function YesNoQuestionType(props: YesNoQuestionProps) {
  return <ContactQuestion {...props} kind="yes_no" />;
}
